import darkmode from '../../assets/darkmode.jpg';

import '../../styles/days.scss';

const Fourteen = () => (
  <div className='days full-image rounded'>
    <img src={darkmode} alt='darkmode toggle' />
  </div>
);

export default Fourteen;
